import { Box } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { OptionalHttpsSchema } from '@/shared/forms/utility/validators'
import { type FormSection, GenericForm } from '../../shared/forms/GenericForm'

export const Route = createFileRoute('/_authenticated/formTest')({
	component: () => <FormTest />,
})

export function FormTest() {
	const [formValues, setFormValues] = useState({})

	const sections: FormSection[] = [
		{
			title: 'All Field Types',
			description: 'Testing all field types with various configurations',
			fields: [
				{
					name: 'textField',
					label: 'Text Field',
					type: 'text',
					initialValue: '',
				},
				{
					name: 'numberField',
					label: 'Number Field',
					type: 'number',
					initialValue: 0,
				},
				{
					name: 'enableUrl',
					label: 'Enable URL Field',
					type: 'checkbox',
					initialValue: false,
				},
				{
					name: 'urlField',
					label: 'URL Field',
					type: 'url',
					initialValue: '',
					validator: OptionalHttpsSchema(),
					disabled: (values) => !values.enableUrl,
				},
				{
					name: 'imageUrlField',
					label: 'Image URL Field',
					type: 'imageUrl',
					initialValue: '',
				},
				{
					name: 'colorField',
					label: 'Color Field',
					type: 'color',
					initialValue: '#000000',
				},
				{
					name: 'fileField',
					label: 'File Field',
					type: 'file',
				},
				{
					name: 'checkboxField',
					label: 'Single Checkbox',
					type: 'checkbox',
					initialValue: false,
				},
				{
					name: 'multiCheckbox',
					label: 'Multi Checkbox',
					type: 'checkbox',
					options: [
						{ value: 'a', label: 'Option A' },
						{ value: 'b', label: 'Option B' },
						{ value: 'c', label: 'Option C' },
					],
					initialValue: [],
				},
				{
					name: 'radioField',
					label: 'Radio Field',
					type: 'radio',
					options: [
						{ value: 'x', label: 'X' },
						{ value: 'y', label: 'Y' },
						{ value: 'z', label: 'Z' },
					],
					initialValue: 'x',
				},
			],
		},
	]

	return (
		<Box sx={{ padding: 4, display: 'flex', flexDirection: 'row', gap: 4 }}>
			<Box sx={{ flex: 1 }}>
				<GenericForm
					sections={sections}
					onSubmit={async (values) => {
						setFormValues(values)
					}}
					fieldComponents={{}}
				/>
			</Box>
			<Box
				sx={{
					flex: 1,
					background: '#f5f5f5',
					borderRadius: 2,
					padding: 2,
					overflow: 'auto',
				}}
			>
				<pre>{JSON.stringify(formValues, null, 2)}</pre>
			</Box>
		</Box>
	)
}
